import React, { createContext, useState } from "react";

const ContractsContext = createContext();

const ContractsContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [mainLoading, setMainLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [countAllRows, setCountAllRows] = useState(0);
  const [allRows, setAllRows] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [status, setStatus] = useState("");

  return (
    <ContractsContext.Provider
      value={{
        page,
        setPage,
        countAllRows,
        setCountAllRows,
        allRows,
        setAllRows,
        loading,
        setLoading,
        searchFilter,
        setSearchFilter,
        mainLoading,
        setMainLoading,
        status,
        setStatus,
      }}
    >
      {children}
    </ContractsContext.Provider>
  );
};

export { ContractsContextProvider, ContractsContext };
